/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.header[_ngcontent-%COMP%]{text-align:center}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvY2hhcnQvY2hhcnQtanMvY2hhcnQtanMtZGVtby5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2tzbWFpL3dlYmRldi9hZG1pbi10ZW1wbGF0ZS9zcmMvYXBwL2NoYXJ0L2NoYXJ0LWpzL2NoYXJ0LWpzLWRlbW8uY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./$$_gendir/src/app/chart/chart-js/chart-js-demo.component.scss.shim.ngstyle.ts